import { motion } from "framer-motion";

const products = [
  { name: "Vela en tarro de diseño", price: 80, image: "/products/vela-tarro.png" },
  { name: "Cubo pequeño", price: 25, image: "/products/cubo-pequeno.png" },
  { name: "Cubo grande", price: 75, image: "/products/cubo-grande.png" },
  { name: "Taza grande", price: 180, image: "/products/taza-grande.png" },
  { name: "Vela frasco pequeño", price: 55, image: "/products/vela-frasco-peq.png" },
  { name: "Vela manzana", price: 120, image: "/products/vela-manzana.png" },
  { name: "Vela base metálica", price: 100, image: "/products/vela-base-metalica.png" },
  { name: "Vela hexagonal", price: 55, image: "/products/vela-hexagonal.png" },
  { name: "Waxmelts bolsita", price: 40, image: "/products/waxmelts-bolsita.png" },
  { name: "Difusor con Waxmelts", price: 140, image: "/products/difusor-waxmelts.png" },
  { name: "Velas sorpresa", price: 50, image: "/products/velas-sorpresa.png" },
  { name: "Vela frasco tapa", price: 200, image: "/products/vela-tarro.png" }, // Placeholder for quota limit
];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

export default function PricingSection() {
  return (
    <section
      id="precios"
      data-testid="pricing-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      {/* Subtle gold glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-[#D4AF37]/3 blur-[150px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
          className="text-center mb-16 md:mb-20"
        >
          <motion.p variants={fadeUp} className="text-xs uppercase tracking-[0.3em] text-[#D4AF37]/80 mb-4">
            Catálogo
          </motion.p>
          <motion.h2
            variants={fadeUp}
            className="font-serif text-4xl md:text-5xl font-normal tracking-tight leading-tight mb-6 text-white"
            data-testid="pricing-heading"
          >
            Nuestros{" "}
            <span className="italic text-[#D4AF37]">productos</span>
          </motion.h2>
          <motion.p
            variants={fadeUp}
            className="text-base md:text-lg text-white/50 leading-relaxed max-w-xl mx-auto"
          >
            Cada pieza es elaborada artesanalmente con ingredientes premium.
            Encuentra el formato perfecto para tu ritual.
          </motion.p>
          <motion.p
            variants={fadeUp}
            className="text-xs text-white/30 mt-4 max-w-xl mx-auto italic"
          >
            * Las imágenes mostradas son con fines ilustrativos.
          </motion.p>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={{ visible: { transition: { staggerChildren: 0.06 } } }}
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6"
        >
          {products.map((product, i) => (
            <motion.a
              key={i}
              href="https://www.instagram.com/serena_candlesmx"
              target="_blank"
              rel="noopener noreferrer"
              variants={fadeUp}
              whileHover={{ y: -4, transition: { duration: 0.25 } }}
              className="group relative bg-[#0F0F0F] border border-[#27272a] overflow-hidden hover:border-[#D4AF37]/40 transition-all duration-500 flex flex-col outline-none focus:ring-1 focus:ring-[#D4AF37]/50"
              data-testid={`pricing-card-${i}`}
            >
              {/* Image Section */}
              <div className="aspect-square w-full overflow-hidden relative">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  data-testid={`pricing-image-${i}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F0F] via-transparent to-transparent opacity-80" />
              </div>

              {/* Content Section */}
              <div className="relative p-5 md:p-6 flex flex-col items-center text-center flex-1">
                {/* Hover glow effect */}
                <div className="absolute inset-0 bg-[#D4AF37]/[0.02] opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />

                <div className="w-6 h-px bg-[#D4AF37]/30 mb-4 group-hover:w-10 transition-all duration-500" />

                <h3 className="relative font-sans text-sm md:text-base font-medium text-white/90 mb-3 leading-snug min-h-[2.5rem] flex items-center">
                  {product.name}
                </h3>

                <div className="relative mt-auto">
                  <span className="text-xl md:text-2xl font-serif font-medium text-[#D4AF37]">
                    ${product.price}
                  </span>
                  <span className="block text-[9px] uppercase tracking-[0.2em] text-white/30 mt-1">
                    MXN
                  </span>
                </div>
              </div>
            </motion.a>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
